module.exports = __webpack_public_path__ + "img/lock.958ea126.png";